import UploadAdData from '../../components/sponsorship/UploadAdData'

function UploadAd() {
  return <UploadAdData />
}

export default UploadAd
